import React from 'react';
import { WrapperInput } from './styles';
import { useField } from '@unform/core';

type InputProps = JSX.IntrinsicElements['input'] & {
  name: string;
  width?: string;
  label?: string;
};

export function TextField({ name, type='text', placeholder, width, ...rest }: InputProps) {
  const inputRef = React.useRef<HTMLInputElement>(null);
  const { fieldName, defaultValue, registerField, error } = useField(name);
  const [internalPlaceHolder, setInternalPlaceHolder] = React.useState(placeholder);
  const isWidth = width || '100%';

  React.useEffect(() => {
    registerField({
      name: fieldName,
      ref: inputRef,
      getValue: ref => ref.current.value,
      setValue: (ref, value) => {
        ref.current.value = value;
      },
      clearValue: ref => {
        ref.current.value = '';
      },
    });
  }, [fieldName, registerField]);

  return (
    <WrapperInput error={!!error}>
      <input
        type={type}
        id={fieldName}
        ref={inputRef}
        style={{ width: isWidth }}
        placeholder={internalPlaceHolder}
        defaultValue={defaultValue}
        onFocus={() => setInternalPlaceHolder('')}
        onBlur={() => {
          if (!inputRef.current?.value) {
            setInternalPlaceHolder(placeholder);
          }
        }}
        {...rest}
      />
    </WrapperInput>
  );
}
